import { FC, useMemo, useState } from "react";
import { View } from "@data-root/react";
import { ScreenProps } from "../../typings";
import { LanguageView as ILanguageView } from "@data-root/types";
import { viewStylesheet } from "..";
import {
  MessageContainer,
  IAction,
  IMessageElement,
  IMessage,
  IMessageContext,
} from "@chainlit/components";
import { Button, Input } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { useAsyncCallback } from "@data-root/react";
import { DialogEntry, dialog_1, dialog_2, dialog_3, dialog_4 } from "./dialogs";

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const LanguageView: FC<ScreenProps<ILanguageView>> = ({ view }) => {
  const [input, setInput] = useState<string>("");
  const [actions, setActions] = useState<IAction[]>([]);
  const [elements, setElements] = useState<IMessageElement[]>([]);
  const [messages, setMessages] = useState<IMessage[]>([]);
  const [i, setI] = useState(0);

  const sendMessage = useAsyncCallback(async () => {
    let dialog: DialogEntry[] = [];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (view.options?.dialog) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      switch (view.options.dialog) {
        case 1:
          dialog = dialog_1;
          break;
        case 2:
          dialog = dialog_2;
          break;
        case 3:
          dialog = dialog_3;
          break;
        case 4:
          dialog = dialog_4;
          break;
        default:
          dialog = dialog_1;
          break;
      }
    } else dialog = dialog_1;

    if (i >= dialog.length) return;
    const entry = dialog[i];

    const userMessage: IMessage = {
      id: `${i}_user`,
      createdAt: Date.now(),
      author: "Felipe Engelberger",
      authorIsUser: true,
      content: input,
    };
    setMessages((messages) => [...messages, userMessage]);
    setActions((actions) => [...actions, ...entry.actions]);
    setElements((elements) => [...elements, ...entry.elements]);
    setInput("");

    for (const message of entry.messages) {
      await wait(1000 * Math.random() + 500);

      const m = {
        ...message,
        createdAt: Date.now(),
      };

      setMessages((messages) => [...messages, m]);
    }

    setI((i) => i + 1);
  }, [i, input, view]);

  const context = useMemo<IMessageContext>(
    () => ({
      avatars: [
        {
          id: "AgGPT",
          type: "avatar",
          name: "AgGPT",
          url: "https://avatars.githubusercontent.com/u/90492622?s=48",
        },
        {
          id: "Cliente",
          type: "avatar",
          name: "Felipe Engelberger",
          url: "https://scholar.googleusercontent.com/citations?view_op=view_photo&user=46TduAoAAAAJ&citpid=2",
        },
      ],
      defaultCollapseContent: false,
      expandAll: false,
      hideCot: false,
      highlightedMessage: null,
      loading: false,
      onElementRefClick: undefined,
      onFeedbackUpdated: undefined,
      onPlaygroundButtonClick: undefined,
      showFeedbackButtons: true,
      onError: () => undefined,
      uiName: "",
    }),
    []
  );

  return (
    <View style={{ ...viewStylesheet.container, ...viewStylesheet.vCenter }}>
      <View
        style={{
          ...viewStylesheet.contentContainer,
          ...viewStylesheet.limitedContentContainer,
        }}
      >
        <MessageContainer
          autoScroll
          actions={actions}
          elements={elements}
          messages={messages}
          context={context}
        />

        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: 10,
            gap: 10,
          }}
        >
          <Input
            width="100%"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message here"
            onPressEnter={sendMessage}
          />

          <Button
            type="primary"
            icon={<SendOutlined />}
            onClick={sendMessage}
          />
        </View>
      </View>
    </View>
  );
};
